import { useTranslation} from 'react-i18next';

import imgMobile from 'assets/images/solutions/modules/qc/ko/modules_mobile.jpg'
import imgPC from 'assets/images/solutions/modules/qc/ko/modules.jpg'

// 이 화면만 별도 디자인
export default function ProductQc(props){
  const {t} = useTranslation();

  return (
    <div className="flex flex-col items-center my-10 px-mobile lg:px-0">
      <p className="text-xl">{t('modules.company.qc.img-title')}</p>
      <p className="mb-10 text-3xl">{t('modules.company.qc.img-desc')}</p>
      <picture>
        <source media="(min-width: 1024px)" srcSet={imgPC}/>
        <img src={imgMobile} alt='QCELLS model'/>
      </picture>
    </div>
  );
}